import React from "react";
import { useSelector } from "react-redux";
import { CustomerCertTemplate } from "../../types/types";
import { getCustomerCertTemplate } from "../certReducer";
import { ImageComponent } from "./ImageComponent";
import { NoTemplate } from "./NoTemplate";
import { Form } from "./TemplateForm";

interface TemplateCardProps {
  templateName: string;
  handleInputChange: (e: any, id: string) => void;
}

interface TemplateProps {
  template: CustomerCertTemplate;
  handleInputChange: (e: any, id: string) => void;
}

const Card = ({ template, handleInputChange }: TemplateProps) => {
  return (
    <div className='relative w-full'>
      <div className='flex justify-around text-3xl text-brand-dark_blue p-4'>
        <div>{template.templateName}</div>
        <div>{template.templateDescription}</div>
      </div>
      <div className='flex'>
        <Form
          questions={template.templateDataModel.templateQuestions}
          handleInputChange={handleInputChange}
        />
        <ImageComponent
          imageUrl={template.templateDataModel.templatePreviewUrl}
        />
      </div>
    </div>
  );
};

export const TemplateCard: React.FC<TemplateCardProps> = ({
  templateName,
  handleInputChange,
}) => {
  const selected = useSelector((cState) =>
    getCustomerCertTemplate(cState, templateName)
  );

  return selected.found ? (
    <div className='m-auto bg-white overflow-auto scroller'>
      <Card
        template={selected.template}
        handleInputChange={handleInputChange}
      />
    </div>
  ) : (
    <NoTemplate />
  );
};

export default TemplateCard;
